export const KENDO_BUTTON_CLASSES = "k-button k-button-sm k-button-clear";
